import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { CartContext } from './CartContext';
import { products } from '../products';
import { FaFire, FaShoppingCart, FaArrowLeft, FaTag } from 'react-icons/fa';
import '../css/VapePensDeal.css';

const VapePensDeal = () => {
  const { addToCart } = useContext(CartContext);

  // Deal data setup with unique IDs
  const deals = [
    {
      id: 'flower-edible-deal',
      name: '1 Oz Exotic Flower & 1 Edible',
      category: 'bundle',
      price: 180,
      quantityText: '1oz Exotic flower & 1 edible',
      products: [
        ...products.filter(p => p.category === 'exotic' && !p.isDeal).slice(0, 1),
        ...products.filter(p => p.category === 'Edibles' && !p.isDeal).slice(0, 1)
      ],
      color: '#382a9d',
      isDeal: true
    },
    {
      id: 'disposable-1g-deal',
      name: '2 2g Disposable Carts',
      category: 'Disposable Cart',
      price: 80,
      quantityText: '2 disposable carts',
      products: products.filter(p => p.category === 'Disposable Cart' && !p.isDeal).slice(0, 2),
      color: '#4cc9f0'
    },
    {
      id: 'disposable-3g-deal',
      name: '4 2g Disposable Carts',
      category: 'Disposable Cart',
      price: 150,
      quantityText: '4 disposable carts',
      products: products.filter(p => p.category === 'Disposable Cart' && !p.isDeal).slice(0, 2),
      color: '#4cc9f0'
    },
    {
      id: 'cartridge-4-deal',
      name: '4 Cartridges Deal',
      category: 'Cartages',
      price: 100,
      quantityText: '4 Cartridges',
      products: products.filter(p => p.category === 'Cartages' && !p.isDeal).slice(0, 2),
      color: '#a625f6'
    },
    {
      id: 'cartridge-8-deal',
      name: '8 Cartridges Deal',
      category: 'Cartages',
      price: 180,
      quantityText: '8 Cartridges',
      products: products.filter(p => p.category === 'Cartages' && !p.isDeal).slice(0, 2),
      color: '#a625f6'
    },
    {
      id: 'edible-6-deal',
      name: '5 Edibles',
      category: 'Edibles',
      price: 100,
      quantityText: '5 edibles',
      products: products.filter(p => p.category === 'Edibles' && !p.isDeal).slice(0, 2),
      color: '#f72585'
    },
    {
      id: 'flower-2oz-deal',
      name: '2oz Flower',
      category: 'flower',
      price: 180,
      quantityText: '2 ounces',
      products: products.filter(p => p.category === 'flower' && !p.isDeal).slice(0, 2),
      color: '#2a9d8f'
    },
    {
      id: 'flower-4oz-deal',
      name: '4oz Flower',
      category: 'flower',
      price: 350,
      quantityText: '4 ounces',
      products: products.filter(p => p.category === 'flower' && !p.isDeal).slice(0, 2),
      color: '#2a9d8f'
    },
    {
      id: 'preroll-10-deal',
      name: '10 Prerolls',
      category: 'Prerolls',
      price: 80,
      quantityText: '10 Prerolls',
      products: products.filter(p => p.category === 'Prerolls' && !p.isDeal).slice(0, 2),
      color: '#4ad66d'
    },
    {
      id: 'preroll-20-deal',
      name: '20 Prerolls',
      category: 'Prerolls',
      price: 150,
      quantityText: '20 Prerolls',
      products: products.filter(p => p.category === 'Prerolls' && !p.isDeal).slice(0, 2),
      color: '#4ad66d'
    },
  ];

  const addDealToCart = (deal) => {
    // Create a deal item that represents the bundle
    const dealItem = {
      id: deal.id,
      name: deal.name,
      price: deal.price,
      quantity: 1,
      image: deal.products[0]?.image || '/potcity/images/default-deal.jpg',
      isDeal: true,
      dealDetails: {
        originalPrice: deal.products.reduce((sum, p) => sum + p.price, 0),
        savings: deal.products.reduce((sum, p) => sum + p.price, 0) - deal.price,
        includedProducts: deal.products.map(p => p.name)
      }
    };

    addToCart(dealItem);
  };

  const calculateSavings = (deal) => {
    const regularPrice = deal.products.reduce((sum, p) => sum + p.price, 0);
    return regularPrice - deal.price;
  };

  const calculateSavingsPercentage = (deal) => {
    const regularPrice = deal.products.reduce((sum, p) => sum + p.price, 0);
    return Math.round(((regularPrice - deal.price) / regularPrice) * 180);
  };

  return (
    <div className="deals-page">
      <div className="deals-header">
        <Link to="/" className="back-link">
          <FaArrowLeft />
          <span>Back to Home</span>
        </Link>
        <div className="header-content">
          <div className="header-icon">
            <FaFire />
          </div>
          <h1>Hot Deals</h1>
          <p>Limited time offers - Don't miss out!</p>
        </div>
      </div>

      <div className="deals-grid">
        {deals.map(deal => {
          const savings = calculateSavings(deal);
          const savingsPercentage = calculateSavingsPercentage(deal);

          return (
            <div key={deal.id} className="deal-card">
              <div className="deal-badge" style={{ backgroundColor: deal.color }}>
                <FaTag />
                <span>Hot Deal</span>
              </div>
              
              <div className="deal-header">
                <h2>{deal.name}</h2>
                <div className="deal-price-section">
                  <div className="deal-price">${deal.price}</div>
                  <div className="savings-badge">
                    Save ${savings} ({savingsPercentage}%)
                  </div>
                </div>
              </div>

              <div className="deal-quantity">
                <span>{deal.quantityText}</span>
              </div>

              <div className="products-preview">
                {deal.products.map((product, index) => (
                  <div key={`${deal.id}-${product.id}-${index}`} className="product-preview">
                    <img src={product.image} alt={product.name} className="product-image" />
                    <div className="product-info">
                      <div className="product-name">{product.name}</div>
                      <div className="original-price">${product.price}</div>
                    </div>
                  </div>
                ))}
              </div>

              <button
                className="add-deal-btn"
                onClick={() => addDealToCart(deal)}
                style={{ backgroundColor: deal.color }}
              >
                <FaShoppingCart />
                <span>Add to Cart</span>
                <span className="deal-price-btn">${deal.price}</span>
              </button>
            </div>
          );
        })}
      </div>

      <div className="deals-footer">
        <Link to="/products" className="more-products-link">
          <FaShoppingCart />
          <span>View All Products</span>
        </Link>
      </div>
    </div>
  );
};

export default VapePensDeal;